import React, { Component } from 'react'
import styled from 'styled-components'

/**
 * Avaliação por estrelas (1 a 5), fiel ao rating.php do WordPress antigo.
 *
 * Props:
 *  - value: número (1..5) atualmente selecionado (0/undefined = nenhuma).
 *  - onChange: (value) => void chamado ao clicar numa estrela.
 *  - name: string usada nos ids/acessibilidade (equivalente a rating_1/2/3).
 */
export default class StarRating extends Component {
  state = {
    hover: 0,
  }

  handleEnter = (value) => this.setState({ hover: value })
  handleLeave = () => this.setState({ hover: 0 })

  render() {
    const { value = 0, onChange, name } = this.props
    const { hover } = this.state
    const active = hover || value

    return (
      <Stars onMouseLeave={this.handleLeave}>
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            type='button'
            aria-label={`${star} de 5`}
            data-name={name}
            filled={star <= active}
            onMouseEnter={() => this.handleEnter(star)}
            onClick={() => onChange && onChange(star)}>
            <svg width='28' height='28' viewBox='0 0 24 24'>
              <path d='M12 17.27l5.18 3.12-1.37-5.9 4.58-3.97-6.03-.52L12 4.5 9.64 10l-6.03.52 4.58 3.97-1.37 5.9L12 17.27z' />
            </svg>
          </Star>
        ))}
      </Stars>
    )
  }
}

const Stars = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Star = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  line-height: 0;

  svg path {
    fill: ${({ filled }) => (filled ? '#93c13e' : '#ececec')};
    transition: fill 0.15s ease;
  }
`



// WEBPACK FOOTER //
// ./src/components/StarRating/index.js